import React from "react"
import { Container, Row, Col } from "reactstrap"
import "./app.css"
import TileContainer from "../containers/TitleContainer"
import invisiBreak from "../assets/pattern-3.svg"
import venueHistory from "../assets/THE WHITE HART INTRO.pdf"
import MapContainer from "./MapContainer";
import "./visit.css"
const Visit = () => {
    const style = {
        width: '100%',
        height: '80%'
    }
    return (
        <Container fluid>
            <TileContainer title={"About Us"} />
            <Row className="row-m-20">
                <Col className="col-m-b-20 remove-padding">
                    <div className="textContainer">
                        <p>The White Hart is a popular tearoom, sandwich bar + B&B set in the heart of Leek. We are located on Stockwell Street just opposite the Market Place and next door to the Foxlowe, our lovely local arts venue.</p>

                        <div style={{ border: "1px solid #333", padding: 20, textAlign: "center", margin: "20px 0" }}>
                            <h3 style={{ marginBottom: 10 }}>Opening Hours</h3>
                            <p style={{ fontSize: 24, marginBottom: 8 }}>8:30am to 2:30pm 7 day a week</p>
                            <p style={{ marginBottom: 0 }}>(24 hour coded access to our B&B is available)</p>
                        </div>

                        <h3>Our History</h3>
                        <p>Our beautiful Grade 2 listed building dates back to the 1500s. Please click <a href={venueHistory} target="_blank" rel="noopener noreferrer" style={{ color: "black" }}>HERE</a> for more information.</p>

                        <h3>Accessibility</h3>
                        <p>Our tearoom and sandwich bar are fully accessible with designated toilet facilities. All B&B rooms are accessed via stairs with a handrail. Please do contact us if you require any further information.</p>

                        <h3>Dog Friendly</h3>
                        <p>We welcome dogs in all areas. We even have a doggie menu! Most of our B&B rooms are dog friendly.</p>
                    </div>
                </Col>
            </Row>
            <Row className="row-m-20">
                <Col className="col-m-b-20 remove-padding">
                    <div className="textContainer">
                        <h3>Parking</h3>
                        <p>While we don't have our own car park, we are within very short walking distance (less than 1 minute) from several town centre car parks.</p>
                        <p>We would recommend Stockwell Street Car Park or Silk Street car park. These car parks operate a charging period of 9.30am to 3.30pm from Monday to Saturday. Which means at weekends they are free between 3:30pm on Saturday and 9:30am on Monday.</p>
                        <p>While parking is also available on Market Place Car Park this is not available on Saturday due to the town's market. Should you be arriving on a Friday please don’t park on Market Place. You may find it very difficult to leave on the Saturday once the stalls have been set up! Occasional other events affect the parking on Market Place, please do check any signage before leaving your vehicle there.</p>
                    </div>
                </Col>
            </Row>
            <Row className="row-m-20">
                <Col className="remove-padding">
                    <div>
                        <img src={invisiBreak} alt="" className="center" style={{ width: "100%", height: "50%", borderRadius: 5, opacity: 0.5 }} />
                    </div>
                </Col>
            </Row>
            <Row className="row-m-20" style={{ height: '70vh', marginBottom: 50 }}>
                <Col className="remove-padding" >
                    <div className="textContainer" style={{ height: '70vh', marginBottom: 50 }}>
                        <h3>Find Us</h3>
                        <p> 1 - 3 Stockwell St, Leek ST13 6DH</p>
                        <MapContainer Style={style} />

                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Visit